import React from 'react';
import Navbar from '../components/Navbar';
import './Venue.css';

const Venue = () => {
    return (
        <div>
            <Navbar />
            <section className="venue section">
                <div className="venue-container">
                    <hr className="divider" /> {/* Top Divider */}
                    <h1 className="section-title">The Venue</h1>
                    <div className="venue-content">
                        <div className="text-and-image">
                            <div className="text">
                                <p>
                                    We are thrilled to celebrate our special day at the stunning <strong>Casa Adela</strong>, nestled in the heart of San Miguel de Allende, Mexico. With its lush gardens, breathtaking architecture, and timeless elegance, Casa Adela is the perfect setting for our wedding.
                                </p>
                                <p>
                                    Casa Adela offers a blend of historic charm and modern luxury, creating a magical atmosphere for our ceremony and reception. Explore its beautiful grounds, relax in its serene spaces, and experience the warmth of San Miguel de Allende's renowned hospitality.
                                </p>
                                <p>
                                    For more information, visit their website: <a href="https://casaadelamexico.com/" target="_blank" rel="noopener noreferrer">Casa Adela</a>.
                                </p>
                            </div>
                        </div>
                    </div>
                    <hr className="divider" /> {/* Bottom Divider */}
                </div>
            </section>
        </div>
    );
};

export default Venue;
